<app-filters-synthesis [filters]="filters" [synthesisFilter]="synthesisFilter" [sourceSynthesis]="sourceSynthesis"
    (decreaseY)="decreaseYear()" (increaseY)="increaseYear()"></app-filters-synthesis>
<app-table-synthesis [filters]="filters" [synthesisFilter]="synthesisFilter"
    (getValueSourceSynthesis)="getValueSourceSynthesis($event)"></app-table-synthesis>
